module.exports = __webpack_public_path__ + "assets/img/Nexon-2-Landing-Page.e9469f0c.webp";